import RecruitApiClient from '../../RecruitApiClient';

class Api {
  getPreferences = () => RecruitApiClient.get(`/api/v4/ui_preferences?source=smart_forms`, null);
  getDensityPreferences = () =>
    RecruitApiClient.get(`/api/v4/ui_preferences?source=universal`, null);
  getSmartForms = (params: {}) => RecruitApiClient.get(`/api/v4/smart_forms`, params);
  getSmartForm = (formId: number) => RecruitApiClient.get(`/api/v4/smart_forms/${formId}`, {});
  getRequisitionForms = (params: {}) => RecruitApiClient.get(`/api/v4/requisition_forms`, params);
  getJobs = (params: {}) => RecruitApiClient.get(`/api/v4/jobs`, params);
  deleteSmartForm = (formId: number) =>
    RecruitApiClient.delete(`/api/v4/smart_forms/${formId}`, {});
  postUserPreferences = (params: {}) => RecruitApiClient.post(`/api/v4/ui_preferences`, params);
  postSmartForm = (params: { form: { name: string; entity_id: number; enabled: boolean } }) =>
    RecruitApiClient.post(`/api/v4/smart_forms`, params);
  updateSmartForm = (
    formId: number,
    params: { form: { name: string; entity_id: number; enabled: boolean } }
  ) => RecruitApiClient.put(`/api/v4/smart_forms/${formId}`, params);
  newField = (formId: number, params: { field: { body: string } }) =>
    RecruitApiClient.post(`/api/v4/fields?form_id=${formId}`, params);
  getSystemFields = () => RecruitApiClient.get(`/api/v4/system_fields?form_type=Form`, {});
  addSystemField = (formId: number, systemFieldId: number) =>
    RecruitApiClient.post(
      `/api/v4/system_fields?form_id=${formId}&system_field_id=${systemFieldId}`,
      {}
    );
  importFields = (formId: number, sourceType: string, selectedId: number) =>
    RecruitApiClient.post(`/api/v4/fields/import`, {
      source_type: sourceType,
      source_id: selectedId,
      form_id: formId
    });
  getQuestions = (params: { entity_id: number; form_id: number }) =>
    RecruitApiClient.get(`/api/v4/fields`, params);
  putQuestion = (id: number, formId: number, params: { field: Record<string, boolean> }) =>
    RecruitApiClient.put(`/api/v4/fields/${id}?form_id=${formId}`, params);
  deleteQuestion = (id: number, formId: number) =>
    RecruitApiClient.delete(`/api/v4/fields/${id}?form_id=${formId}`, {});
  cloneQuestion = (id: number, formId: number) =>
    RecruitApiClient.post(`/api/v4/fields/${id}/clone?form_id=${formId}`, {});
  getTargetEntities = () => RecruitApiClient.get(`/api/v4/target_entities`, {});
  cloneForm = (
    formId: number,
    params: { form: { name: string; entity_id: number; enabled: boolean } }
  ) => RecruitApiClient.post(`/api/v4/smart_forms/${formId}/clone`, params);
  updateQuestions = (formId: number, params: { fields: Record<string, { position: number }> }) =>
    RecruitApiClient.put(`/api/v4/smart_forms/${formId}/update_questions`, params);
}

export default new Api();
